import classNames from 'classnames';
import PropTypes from 'prop-types';
import Styles from './Logo.module.scss';

import Poly from './svg/poly.inline.svg';

const Logo = ({ className, type, site = '1', ...props }) => {
  const logoSize = Styles.polyLogo;
  return <Poly className={classNames(logoSize, className, type)} {...props} />;
};

Logo.propTypes = {
  className: PropTypes.string,
  type: PropTypes.string,
};

Logo.Type = {
  WHITE: Styles.white,
  BLACK: Styles.black,
  BLUE: Styles.blue,
  DARKBLUE: Styles.darkblue,
  DARKGRAY: Styles.darkgray,
};

export default Logo;
